import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "undo",
	"data-name": "undo",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 2.41,6.940287 h 12.44 a 7.65,7.65 0 0 1 7.65,7.65 v 0 a 7.65,7.65 0 0 1 -7.65,7.65 H 0.5",
			id: "path6"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "8.15 22.52 2.41 16.78 8.15 11.04",
			id: "polyline8",
			transform: "matrix(1,0,0,-1,0,23.720287)"
		})
	]
});
const ForwardRef = forwardRef(SvgUndo);
export default ForwardRef;
